import Component from "./login";

import {bindActionCreators} from "redux";
import {loginUser} from '../../store/actions/session';
import connect from "react-redux/es/connect/connect";



function mapStateToProps(state) {
    const session = state.session;

    return {
        session
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({loginUser}, dispatch);
}

export const Login = connect(mapStateToProps, mapDispatchToProps)(Component);